export default __webpack_public_path__ + "icon824ba57.png";